/**
 * @generated SignedSource<<dbc0623550f79563044fe7062f221471>>
 * @relayHash bf3054529c861ddf57e417b8353c5e75
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d58864bfd727a6a990093d38b221289af4e6aaa7f96d570e63e81c6a5f323e1c

import type { ConcreteRequest, Query } from 'relay-runtime';
export type linkPickerResolversArticlesQuery$variables = {
  cloudId: string;
  helpCenterAri?: string | null | undefined;
  limit: number;
  queryTerm: string;
};
export type linkPickerResolversArticlesQuery$data = {
  readonly helpObjectStore_searchArticles: {
    readonly results?: ReadonlyArray<{
      readonly ari: string;
      readonly displayLink: string;
      readonly title: string;
    }>;
  } | null | undefined;
};
export type linkPickerResolversArticlesQuery = {
  response: linkPickerResolversArticlesQuery$data;
  variables: linkPickerResolversArticlesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "helpCenterAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryTerm"
},
v4 = [
  {
    "kind": "Literal",
    "name": "categoryIds",
    "value": ([]/*: any*/)
  },
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  },
  {
    "kind": "Variable",
    "name": "limit",
    "variableName": "limit"
  },
  {
    "kind": "Literal",
    "name": "portalIds",
    "value": ([]/*: any*/)
  },
  {
    "kind": "Variable",
    "name": "queryTerm",
    "variableName": "queryTerm"
  }
],
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "HelpObjectStoreArticleSearchResult",
      "kind": "LinkedField",
      "name": "results",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "ari"
        },
        {
          "kind": "ScalarField",
          "name": "title"
        },
        {
          "kind": "ScalarField",
          "name": "displayLink"
        }
      ]
    }
  ],
  "type": "HelpObjectStoreArticleSearchResults"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "linkPickerResolversArticlesQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "kind": "LinkedField",
        "name": "helpObjectStore_searchArticles",
        "plural": false,
        "selections": [
          (v5/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "linkPickerResolversArticlesQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "kind": "LinkedField",
        "name": "helpObjectStore_searchArticles",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "d58864bfd727a6a990093d38b221289af4e6aaa7f96d570e63e81c6a5f323e1c",
    "metadata": {},
    "name": "linkPickerResolversArticlesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "da1241cff38e2e9fd36d5c09b42edca7";

export default node;
